import { Checkbox, FormControlLabel } from '@mui/material';
import { useCaseFieldData, useCaseFieldDispatch } from '../../hooks/useCaseField';
import type { FieldMode } from '../../hooks/useCaseField';
import type { MedNecCaseView } from '../../../../services/MedNecService/types/medNecTypes';

interface CaseCheckboxFieldProps {
  mode: FieldMode;
  label: string;
  getValue: (data: MedNecCaseView) => boolean;
  getUpdate: (checked: boolean, data: MedNecCaseView) => Partial<MedNecCaseView>;
}

const CaseCheckboxField: React.FC<CaseCheckboxFieldProps> = ({ mode, label, getValue, getUpdate }) => {
  const data = useCaseFieldData(mode);
  const { dispatchUpdate, readOnly } = useCaseFieldDispatch(mode);

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={getValue(data)}
          onChange={e => dispatchUpdate(getUpdate(e.target.checked, data))}
          size="small"
          disabled={readOnly}
        />
      }
      label={label}
    />
  );
};

export default CaseCheckboxField;
